import { render, staticRenderFns } from "./qaList.vue?vue&type=template&id=3223b2ed&scoped=true&lang=html&"
import script from "./qaList.vue?vue&type=script&lang=js&"
export * from "./qaList.vue?vue&type=script&lang=js&"
import style0 from "./qaList.vue?vue&type=style&index=0&id=3223b2ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3223b2ed",
  null
  
)

export default component.exports